import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "../content";

const SITE_URL = "https://ridgehawk.ca";

export default function SEO({ title, description, keywords, path = "/", noindex = false }) {
  const fullTitle = title || `${SITE.name} — Precision Logistics`;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <link rel="canonical" href={url} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}
      {noindex ? <meta name="googlebot" content="noindex,nofollow" /> : null}
      {noindex ? <meta name="prerender-status-code" content="404" /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:image" content={`${SITE_URL}/logo.jpeg`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={`${SITE_URL}/logo.jpeg`} />
    </Helmet>
  );
}
